/**
 * Created by vsliwka on 30/05/2017.
 */

export class WorkRestrictionModel {
  public id: number;
  public countryIsoCode: string;
  public type: string;
  public label: string;
  public code: string;
  public order: number;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
